export default "__VITE_ASSET__0144d1dd__"